/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseBodyGeneric } from './response-body-generic';
import { IResponseWithErrorGeneric } from './iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
//</custom-head>

export class ResponseWithErrorGeneric<TBody extends ResponseBodyGeneric<TResult>, TResult> implements IResponseWithErrorGeneric<TResult> {
  public result: TResult;
  public error: string = undefined;
  public message: string = undefined;
  public requestValidationErrors: { [key: string]: string; };
  public httpStatus: number = undefined;
  public httpStatusText: string = undefined;
  public body: TBody;

  //<custom-body>
  private wrapper: ResponseWithErrorGeneric<TBody, TResult>;

  constructor(response: HttpResponse<ResponseWithErrorGeneric<TBody, TResult>> | HttpErrorResponse | string, defaultResult: TResult) {
    if ((response instanceof HttpResponse) || (response instanceof HttpErrorResponse)) {
      this.httpStatus = response.status;
      this.httpStatusText = response.statusText;

      if (response instanceof HttpResponse)
        this.wrapper = response.body;
      else if (response instanceof HttpErrorResponse)
        this.wrapper = response.error;

      try {
        this.body = this.wrapper.body;
      } catch (e) {
        this.body = (response as any).body;
      }
      this.result = this.wrapper ? this.wrapper.result : defaultResult;

      if (!this.wrapper && !this.body) return;

      if (this.wrapper.message) this.message = this.wrapper.message;
      if (this.wrapper.error) this.error = this.wrapper.error;
      if (!this.body) return;

      if (this.body.exceptionMessage) {
        this.error = `${this.wrapper.message} (${this.body.exceptionType}): ${this.body.exceptionMessage}`;
      } else {
        this.error = this.wrapper.error || this.body.error;
      }

      if (this.body.modelState) {
        if (this.error == null || this.error === '') {
          this.error = 'Validering misslyckades';
        }

        this.requestValidationErrors = this.requestValidationErrors || {};
        for (const key in this.body.modelState) {
          if (this.body.modelState.hasOwnProperty(key)) {
            // FIXME: API returns request.<fieldName>, so strip out the crap in front.
            //        Should be done on the server-side, but simpler to test here first.
            const validationKey = key.indexOf('.') > -1 ? key.split('.')[1] : key;
            this.requestValidationErrors[validationKey] = this.body.modelState[key].join(', ');
          }
        }
      }
    } else {
      this.result = defaultResult;
      this.error = response && (response as any).message ? (response as any).message : response;
    }
  }
  //</custom-body>
}
